export function eraseHtml(html) {
  return html.replace(/<[^>]+>/g, '');
}

/**
 *将 Date 转化为指定格式的String
 *月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *例子：
 *(new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 *(new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export function date2Str(date, fmt) {
  if (!date) return undefined;

  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length)); }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : (`00${o[k]}`).substr((`${o[k]}`).length),
      );
    }
  }
  return fmt;
}

// 字符串转日期格式，strDate要转为日期格式的字符串
export function str2Date(strDate, daySeprator = '/') {
  const st = strDate;
  const a = st.split(' ');
  const b = a[0].split(daySeprator);

  let c = [0, 0, 0];
  if (a.length >= 2) {
    c = a[1].split(':');
    if (c.length === 2) {
      c[2] = 0;
    }
  }
  const date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
  return date;
}
